import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityHistoryListTemplate } from "themes/application/facility/pages";
import { FacilityHistoryListViewStore } from "application/facility/stores";

@setCurrentView(rootStore => new FacilityHistoryListViewStore(rootStore), "facilityHistoryListViewStore")
@observer
class FacilityHistoryList extends React.Component {
    render() {
        return <FacilityHistoryListTemplate {...this.props} />;
    }
}

export default FacilityHistoryList;